/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskActionResultSummary } from './taskActionResultSummary';
import { ActionResultSummary } from './actionResultSummary';
import { TargetSummary } from './targetSummary';


export interface RolloutWaveSummary { 
    targets_summary?: Array<TargetSummary>;
    actions_summary?: Array<ActionResultSummary>;
    /** @deprecated */
    tasks_summary?: Array<TaskActionResultSummary>;
}

